import React from 'react';
import PropTypes from 'prop-types';
import { TableRow, TableData } from '@welldev-group/rcl-table';
import { I18nText } from '@welldev-group/react-comp-lib';
import classNames from 'classnames';
import DateTime from '../../DateTime';
import ShowMoreAffiliates from '../../ShowMoreAffiliates';
import PlanEmphasisTag from './PlanEmphasisTag';

const AffiliateRow = ({
  affiliateName,
  accountManager,
  activeUsers,
  bookings,
  issuedTickets,
  plan,
  subscriptionPeriod,
  workspaces,
  affiliateId,
  lastLogin,
  deactivatedAffiliates,
  showDetailsUrl,
  onConfirmationModalDismiss,
  totalChannels,
}) => {
  const ZERO = '0';

  const lastLoginContent = lastLogin ? (
    <DateTime dateTime={lastLogin} />
  ) : (
    <I18nText id="affiliate_three_sixty.affiliate_list.table.label.not_available" />
  );

  return (
    <TableRow>
      <TableData
        className={
          affiliateName
            ? 'affiliate-list__table-row-field--header'
            : 'affiliate-list__table-row-field--disabled'
        }
      >
        {affiliateName || I18n.t('shared.empty_affiliate_name')}
      </TableData>
      <TableData
        align="center"
        className={classNames({
          'affiliate-list__table-row-field--disabled': !accountManager,
        })}
      >
        {accountManager}
      </TableData>
      <TableData
        align="center"
        className={
          activeUsers === ZERO
            ? 'affiliate-list__table-row-field--disabled'
            : null
        }
      >
        {activeUsers}
      </TableData>
      <TableData
        align="center"
        className={classNames({
          'affiliate-list__table-row-field--disabled': Number(bookings) === 0,
        })}
      >
        {bookings}
      </TableData>
      <TableData
        align="center"
        className={classNames({
          'affiliate-list__table-row-field--disabled': Number(issuedTickets) === 0
        })}
      >
        {issuedTickets}
      </TableData>
      <TableData align="center">
        <PlanEmphasisTag plan={plan} subscriptionPeriod={subscriptionPeriod} />
      </TableData>
      <TableData
        align="center"
        className={
          workspaces === ZERO
            ? 'affiliate-list__table-row-field--disabled'
            : null
        }
      >
        {workspaces}
      </TableData>
      <TableData align="center">{lastLoginContent}</TableData>
      <TableData align="center">
        <ShowMoreAffiliates
          deactivatedAffiliates={deactivatedAffiliates}
          showDetailsUrl={showDetailsUrl}
          affiliateId={affiliateId}
          affiliateName={affiliateName}
          onConfirmationModalDismiss={onConfirmationModalDismiss}
          plan={plan}
          subscriptionPeriod={subscriptionPeriod}
          activeUsers={activeUsers}
          workspaces={workspaces}
          totalChannels={totalChannels}
        />
      </TableData>
    </TableRow>
  );
};

AffiliateRow.defaultProps = {
  lastLogin: null,
  totalChannels: 0,
};

AffiliateRow.propTypes = {
  affiliateId: PropTypes.number.isRequired,
  affiliateName: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
    .isRequired,
  activeUsers: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
    .isRequired,
  accountManager: PropTypes.string.isRequired,
  plan: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  bookings: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  issuedTickets: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  subscriptionPeriod: PropTypes.string.isRequired,
  workspaces: PropTypes.oneOfType([PropTypes.node, PropTypes.number])
    .isRequired,
  lastLogin: PropTypes.string,
  showDetailsUrl: PropTypes.string.isRequired,
  onConfirmationModalDismiss: PropTypes.func.isRequired,
  deactivatedAffiliates: PropTypes.bool.isRequired,
  totalChannels: PropTypes.number,
};

export default AffiliateRow;
